<template>
    <div class="repriseForm">
        <Header :code="code">Reprise</Header>
        <v-container>
            <v-row>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="reprise.marque" :label="$t('messages.reprise.marque')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="reprise.modele" :label="$t('messages.reprise.modele')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-select v-model="reprise.carburant" :items="energieItems" :label="$t('messages.reprise.energie')" hide-details></v-select>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-select v-model="reprise.boite_de_vitesse" :items="boiteItems" :label="$t('messages.reprise.boite')" hide-details></v-select>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="reprise.finition" :label="$t('messages.reprise.finition')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="reprise.immatriculation" :label="$t('messages.reprise.immatriculation')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-text-field v-model="reprise.kilometrage" :label="$t('messages.reprise.kilometrage')" hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-menu
                        ref="achat"
                        v-model="achat"
                        :close-on-content-click="false"
                        :return-value.sync="date_achat"
                        transition="scale-transition"
                        offset-y
                        hide-details
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formatDateAchat"
                            :label="$t('messages.reprise.date_achat')"
                            prepend-icon="mdi-calendar"
                            readonly
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date_achat"
                        no-title
                        scrollable
                        @change="$refs.achat.save(date_achat)"
                        >
                        
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-menu
                        ref="mec"
                        v-model="mec"
                        :close-on-content-click="false"
                        :return-value.sync="date_mec"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formatDateMec"
                            :label="$t('messages.reprise.mec')"
                            prepend-icon="mdi-calendar"
                            readonly
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date_mec"
                        no-title
                        scrollable
                        @change="$refs.mec.save(date_mec)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                 <v-col cols="12" class="btnGroup">
                    {{$t('messages.reprise.financement_encours')}}
                    <v-btn-toggle    
                    v-model="reprise.financement"                          
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        <v-btn :value="null">
                            {{$t('messages.todo.nc')}}
                        </v-btn>
                        <v-btn :value="true">
                            {{$t('messages.todo.oui')}}
                        </v-btn>
                        <v-btn :value="false">
                            {{$t('messages.todo.non')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col cols="12" class="formCol">
                    <v-menu
                        ref="finance"
                        v-model="finance"
                        :close-on-content-click="false"
                        :return-value.sync="date_finance"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formatDateFinance"
                            :label="$t('messages.reprise.end_financement')"
                            prepend-icon="mdi-calendar"
                            readonly
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date_finance"
                        locale="fr-fr"
                        no-title
                        scrollable
                        @change="$refs.finance.save(date_finance)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        name="input-7-1"
                        label="Commentaire"
                        v-model="reprise.description"
                        hide-details 
                    ></v-textarea>
                </v-col>
                <v-col cols="12" v-if="mode == 'create'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click="$router.go(-1)">Annuler</v-btn>
                    <v-btn depressed color="primary" @click="createReprise">Enregistrer</v-btn>
                </v-col>
                <v-col cols="12" v-if="mode == 'edit'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click="deleteConfirm = true">Supprimer</v-btn>
                    <v-btn depressed color="primary" @click="modifyReprise">Modifier</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
        v-model="deleteConfirm"
        persistent
        max-width="290"
        >
            <v-card>
                <v-card-title class="">
                Êtes-vous sûr de vouloir effacer le véhicule ?
                </v-card-title>
                <v-card-text>Ceci est une action irréversible.</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey darken-1"
                    text
                    @click="deleteConfirm = false"
                >
                    Annuler
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="deleteReprise">
                    Effacer
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Header from '@/components/Header'
export default {
    name:"RepriseForm",
    props: ['code', 'id', 'mode'],
    components: {
        Header
    },
    data() {
        return {
            projet: {},
            lead: {},
            repriseToModify: {},
            energieItems: ["Diesel", "Essence", "Hybride", "Electrique"],
            boiteItems: ["Manuelle", "Automatique"],
            date_achat: "",
            date_mec:"",
            date_finance:"",
            achat: false,
            mec: false,
            finance:false,
            deleteConfirm:false,
            reprise: {
                type:"REPRISE",
                marque:"",
                modele:"",
                kilometrage:"",
                carburant:"",
                boite_de_vitesse: "",
                immatriculation:"",
                finition:"",
                date_mec:"",
                date_achat: "",
                description:"",
                financement:"",
                date_fin_financement:""
            }
        }
        
    },
    created() {

        if(Object.keys(this.$store.state.detailLead).length === 0 || Object.keys(this.$store.state.leads).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    const lead = this.$store.state.leads.find(e => e.id == this.id);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        this.lead = this.$store.state.leads.find(e => e.id == this.id);
                        this.projet = this.$store.state.projets.find((e) => {
                            return e.code_projet == this.code 
                        })
                        if(this.$store.state.loader){
                            this.$store.dispatch('setLoader', false)
                        }
                        if(this.mode == "edit"){
                            this.repriseToModify = this.$store.state.detailLead.vehicules.find((e) => e.type == "REPRISE");
                            this.reprise.marque = this.repriseToModify.marque,
                            this.reprise.modele = this.repriseToModify.modele,
                            this.reprise.kilometrage = this.repriseToModify.kilometrage,
                            this.reprise.carburant = this.repriseToModify.energie,
                            this.reprise.boite_de_vitesse = this.repriseToModify.boite,
                            this.reprise.immatriculation = this.repriseToModify.immatriculation,
                            this.reprise.finition = this.repriseToModify.finition,
                            this.reprise.description = this.repriseToModify.commentaire
                            //financement
                            if(this.repriseToModify.financement === null || this.repriseToModify.financement === 0){
                                this.reprise.financement = null
                            }else if(this.repriseToModify.financement === "NON"){
                                this.reprise.financement = false
                            }else if(this.repriseToModify.financement === "OUI"){
                                this.reprise.financement = true
                            }
                            this.date_achat = this.parseDate(this.repriseToModify.date_achat)
                            this.date_mec = this.parseDate(this.repriseToModify.date_mec)
                            this.date_finance = this.parseDate(this.repriseToModify.fin_financement)
                        }
                    }) 
                })                
            })
        } else {
            this.lead = this.$store.state.leads.find(e => e.id == this.id);
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code 
            })
            if(this.$store.state.loader){
                this.$store.dispatch('setLoader', false)
            }
            if(this.mode == "edit"){
                this.repriseToModify = this.$store.state.detailLead.vehicules.find((e) => e.type == "REPRISE");
                this.reprise.marque = this.repriseToModify.marque,
                this.reprise.modele = this.repriseToModify.modele,
                this.reprise.kilometrage = this.repriseToModify.kilometrage,
                this.reprise.carburant = this.repriseToModify.energie,
                this.reprise.boite_de_vitesse = this.repriseToModify.boite,
                this.reprise.immatriculation = this.repriseToModify.immatriculation,
                this.reprise.finition = this.repriseToModify.finition,
                this.reprise.description = this.repriseToModify.commentaire
                //financement
                if(this.repriseToModify.financement === null || this.repriseToModify.financement === 0){
                    this.reprise.financement = null
                }else if(this.repriseToModify.financement === "NON"){
                    this.reprise.financement = false
                }else if(this.repriseToModify.financement === "OUI"){
                    this.reprise.financement = true
                }
                this.date_achat = this.parseDate(this.repriseToModify.date_achat)
                this.date_mec = this.parseDate(this.repriseToModify.date_mec)
                this.date_finance = this.parseDate(this.repriseToModify.fin_financement)
            }
        }


        
    },
    computed: {
        formatDateAchat(){
            return this.transformDate(this.date_achat)
        },
        formatDateMec(){
            return this.transformDate(this.date_mec)
        },
        formatDateFinance(){
            return this.transformDate(this.date_finance)
        }
    },
    methods: {
        transformDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null
            const [day, month, year] = date.split('/')
            return `${year}-${month}-${day}`
        },
        createReprise(){
            this.reprise.date_mec = this.formatDateMec;
            this.reprise.date_achat = this.formatDateAchat;
            this.reprise.date_fin_financement = this.formatDateFinance;
            const payload = {
                code_lead: this.lead.code_lead,
                id_utilisateur: this.$store.state.user.id,
                data: this.reprise
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('addVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        },
        modifyReprise(){
            this.reprise.date_mec = this.formatDateMec;
            this.reprise.date_achat = this.formatDateAchat;
            this.reprise.date_fin_financement = this.formatDateFinance;
            const payload = {
                id_vehicule: this.repriseToModify.id,
                id_utilisateur: this.$store.state.user.id,
                data: this.reprise
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('modifyVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        },
        deleteReprise(){
            const payload = {
                id_vehicule: this.repriseToModify.id,
                id_utilisateur: this.$store.state.user.id,
            }
            console.log("delete")
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('deleteVehicule', payload).then((e) => {
                    this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                    })
                })
            })
        }
    },
}
</script>
<style lang="scss">
    .repriseForm {
        padding-top:8vh;

        .btnGroup  {
            display:flex;
            align-items: center;
            justify-content: space-between;
            padding: 4px 12px;
            margin-top:4px;
            .v-btn {
                margin:0;
            }
        }
        
    }
    .confirmDelete {
        .headline {
            font-size:1em;
        }
    }
</style>